import { createContext } from "react";
import type { useEditQuestionFormGenerator } from "./hooks";

type QuestionFormApi = ReturnType<typeof useEditQuestionFormGenerator>;

export const EditQuestionFormContext = createContext<QuestionFormApi | null>(null);
